var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentOrLoading',[(_setup.svg)?_c(_setup.ShowSvgSectionsComponent,{attrs:{"secciones":_vm.secciones,"zona_id":_vm.zona_id,"svg":_setup.svg},on:{"clickZona":_setup.clickRegion}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }